module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2dnqxW/tc-custom/9783944389820_IMGJPG_FrontCover_0.jpg?1703042290429",
      "alt": "This image is the cover for the book Out on the Pampas - Or, The Young Settlers, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Out on the Pampas - Or, The Young Settlers, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"On The Pampas The Young Settlers\" is the fourth adventure novel by eng writer G.A. Henty. The reader accompanies young  engmen who leave their home country to go Argentina with their families. They have to endure many adventures at the time of the Mexican - American War including a raid by the Pampas Indians in which their sister is abducted. They rescue the girl, make peace with the Indians, and return prosperously to England.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      G. A. Henty\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("George Alfred Henty (8 December 1832 – 16 November 1902) was a prolific English novelist and war correspondent. He is best known for his historical adventure stories that were popular in the late 19th century. His works include The Dragon & The Raven (1886), For The Temple (1888), Under Drake's Flag (1883) and In Freedom's Cause (1885). (Wikipedia)")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0